module.exports = {
	"id": "CX",
	"name": "Christmas Island",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": null,
			"49": null,
			"50": 3.981699,
			"51": 2.466206,
			"52": 3.219246,
			"53": 21.781682,
			"54": 3.219246,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.37652,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": 3.030986,
			"43": null,
			"44": null,
			"45": null,
			"46": 6.815012,
			"47": 2.466206,
			"48": 6.061972,
			"49": 8.716438,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.75304,
			"41": 1.327233,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.18826,
			"8": null,
			"9": null,
			"10": 2.654466,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 3.595766
		},
		"ios_saf": {
			"8": 0,
			"10": 0.267648050791,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00721280526644,
			"8.1-8.4": 0.0133253521024,
			"9.0-9.2": 0.00635704870941,
			"9.3": 0.0969857431307
		},
		"android": {
			"3": 0,
			"4": 0,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0,
			"4.1": 0,
			"4.2-4.3": 0,
			"4.4": 0,
			"4.4.3-4.4.4": 0
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.75304,
			"9": 6.626752,
			"10": 0.37652,
			"11": 4.922999,
			"5.5": null
		},
		"op_mob": {
			"0": 0,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0
		},
		"edge": {
			"12": 9.657738,
			"13": 0.37652,
			"14": 0.37652
		},
		"ie_mob": {
			"10": 0.192949380282,
			"11": 0.785579619718
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": null
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0
		},
		"and_chr": {
			"0": 3.717471
		},
		"and_ff": {
			"0": 0.782471
		}
	},
	"total": 99.614067
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CX.json
 ** module id = 503
 ** module chunks = 0
 **/